import { FC } from 'react';
import { Text } from '@chakra-ui/react';

import { WorkflowStepFormFieldTextarea } from '../types/workflowStepComponentTypes';
import { FieldToBlock, FieldValueProps } from './declarations';
import { commonFieldBlockProps } from './FieldUtils';

export const XmlFieldToBlock: FieldToBlock<
  'xml',
  WorkflowStepFormFieldTextarea
> = (field) => ({
  ...commonFieldBlockProps(field),
  componentType: 'textarea',
  componentProps: {
    size: 'sm',
  },
});

type XmlFieldValueProps = FieldValueProps<'xml'>;

export const XmlFieldValue: FC<XmlFieldValueProps> = ({ field }) => (
  <Text>{field.value}</Text>
);
